// TODO: remove after refactoring
import { setHasProjects } from '@/entities/project/model/useProjectsStore';

import { AUTH_API } from '@/shared/api/amplify';
import { queryClient } from '@/shared/config';
import { LS_DUBBING_WARNING_MODAL_DISABLED } from '@/shared/constants/dubbing';
import { clearUserChurnkeyState } from '@/shared/thirdParty/churnkey';
import { GTMEvents } from '@/shared/thirdParty/gtm';
import { shutdownMixpanel } from '@/shared/thirdParty/mixpanel';

import { clearTusLSEntries } from './tus';

export const logout = async () => {
  localStorage.removeItem(LS_DUBBING_WARNING_MODAL_DISABLED);

  clearUserChurnkeyState();
  shutdownMixpanel();

  GTMEvents.setUserId(undefined);
  queryClient.clear();
  setHasProjects(false);
  clearTusLSEntries.all();

  await AUTH_API.signOut();

  window.location.reload();
};
